export default [
  {
    path: '/modules/financial/negociacao',
    component: () => import('@/views/modules/financial/negociacao/Negociacao.vue'),
    meta: {
      action: ['ROLE_PARCELAMENTO_CONSULTAR'],
      resource: 'ACL',
      pageTitle: 'Negociações',
      renegociacao: true,
      breadcrumb: [
        {
          text: 'Módulo Financeiro | Negociações',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'negociacao',
        component: () => import(
          '@/views/modules/financial/negociacao/grid/NegociacaoGrid.vue'
        ),
        meta: {
          pageTitle: 'Negociações',
          action: 'ROLE_PARCELAMENTO_CONSULTAR',
          resource: 'ACL',
          renegociacao: true,
          breadcrumb: [
            {
              text: 'Módulo Financeiro | Negociações',
            },
          ],
        },
      },
      {
        path: 'editnegociacao/:id',
        name: 'editnegociacao',
        component: () => import(
          '@/views/modules/financial/negociacao/form/NegociacaoForm.vue'
        ),
        meta: {
          pageTitle: 'Visualizando Negociação',
          action: ['ROLE_PARCELAMENTO_CONSULTAR', 'ROLE_PARCELAMENTO_ATUALIZAR'],
          resource: 'ACL',
          renegociacao: true,
          breadcrumb: [
            {
              text: 'Modulo Financeiro | Detalhes da Negociação',
            },
          ],
        },
      },
    ],
  },
]
